// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"1537e021","79":"de7d9867","124":"d0cc4172","144":"475c3a62","315":"eadef80e","379":"680421ce","416":"738ac8a1","610":"781e4e45","787":"51258b7f","835":"c1d9e38b"}[chunkId] + ".chunk.js";
};